import React from 'react';
import { Button, ButtonGroup, Space, TextBody, TextHeading, useModalContext, } from '@ally/metronome-ui';
import styled from 'styled-components';
import { space } from 'styled-system';
const StyledTextHeading = styled(TextHeading)(space);
const headingRef = React.createRef();
export const ConfirmNavigationModal = ({ resetConfirmModal, url, }) => {
    const { setOpen } = useModalContext();
    const handleContinue = () => {
        setOpen(false);
        window.open(url, '_blank');
    };
    React.useEffect(() => {
        var _a;
        (_a = headingRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledTextHeading, { tag: "h1", size: "md", mb: "md", pr: "lg", tabIndex: -1, ref: headingRef }, "Important Notice"),
        React.createElement(StyledTextHeading, { tag: "h2", size: "xs", mb: "sm" }, "You\u2019re leaving ally.com"),
        React.createElement(TextBody, { tag: "p", size: "sm" },
            "Selecting",
            ' ',
            React.createElement(TextBody, { tag: "span", size: "sm", weight: "bold" }, "Continue"),
            ' ',
            "will take you to a website that Ally does not own or control. We are not responsible for the products, services or information you may find or provide there. Also, you should read and understand how that site\u2019s privacy policy, level of security and terms and conditions may impact you."),
        React.createElement(Space, { mt: "xl" },
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { variant: "primary", text: "Continue", onClick: () => {
                        handleContinue();
                        resetConfirmModal();
                    }, "data-testid": "confirm-leave-page" }),
                React.createElement(Button, { variant: "secondary", text: "Cancel", onClick: () => resetConfirmModal() })))));
};
//# sourceMappingURL=ConfirmNavigationModal.js.map